import XeroSvg from '../../../../assets/integration-icons/xero.svg';
import AiqSvg from '../../../../assets/integration-icons/aiq.svg';
import CsvSvg from '../../../../assets/integration-icons/csv.svg';
import OpenApiIcon from '../../../../assets/integration-icons/chaser.svg';
import FreeAgentSvg from '../../../../assets/integration-icons/freeAgent.svg';
import FreshBooksSvg from '../../../../assets/integration-icons/freshbooks.svg';
import MicrosoftDynamicsSvg from '../../../../assets/integration-icons/microsoftDynamics.svg';
import MyYobSvg from '../../../../assets/integration-icons/myYob.svg';
import SageSvg from '../../../../assets/integration-icons/sage.svg';
import Sage200Png from '../../../../assets/logos/sage200.png';
import SageIntacctPng from '../../../../assets/logos/sageintacct.png';
import Sage50Png from '../../../../assets/logos/sage50.png';
import ZapierPng from '../../../../assets/logos/zapier.png';
import ZohoBooksSvg from '../../../../assets/integration-icons/zohobooks.svg';
import QboSvg from '../../../../assets/integration-icons/qbo.svg';
import NetsuiteSvg from '../../../../assets/integration-icons/netsuite.svg';
import D365bcSvg from '../../../../assets/integration-icons/d365bc.svg';
import OdooSvg from '../../../../assets/integration-icons/odoo.svg';
import StripeSvg from '../../../../assets/integration-icons/stripe.svg';

import { Integrations } from '../../../../util/constants';

const getIntegrationIcon = accountingIntegrationSoftware => {
  switch (accountingIntegrationSoftware) {
    case Integrations.XERO:
      return XeroSvg;
    case Integrations.CSV:
      return CsvSvg;
    case Integrations.FREEAGENT:
      return FreeAgentSvg;
    case Integrations.FRESHBOOKS:
      return FreshBooksSvg;
    case Integrations.DYNAMICS:
      return MicrosoftDynamicsSvg;
    case Integrations.MYOB:
      return MyYobSvg;
    case Integrations.SAGECLOUD:
      return SageSvg;
    case Integrations.SAGE:
      return SageSvg;
    case Integrations.SAGE200:
      return Sage200Png;
    case Integrations.SAGEINTACCT:
      return SageIntacctPng;
    case Integrations.ZOHOBOOKS:
      return ZohoBooksSvg;
    case Integrations.ACCOUNTSIQ:
      return AiqSvg;
    case Integrations.QUICKBOOKS:
      return QboSvg;
    case Integrations.NETSUITE:
      return NetsuiteSvg;
    case Integrations.D365BC:
      return D365bcSvg;
    case Integrations.OPENAPI:
      return OpenApiIcon;
    case Integrations.ZAPIER:
      return ZapierPng;
    case Integrations.SAGE50:
      return Sage50Png;
    case Integrations.ODOO:
      return OdooSvg;
    case Integrations.STRIPE:
      return StripeSvg;
    default:
      return '';
  }
};

export default getIntegrationIcon;
